export default {
    namespaced: true,
    state: {
        bread_active: null,
        bread_list: null,
        votesListData: null,
        voteResult: true,
        hideFormProposal: false,
        singleProposal: '',
        versionData: null,
    },
    getters: {},
    mutations: {
        SET_DATA(state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        votesList(state) {
            axios.get('/api/v2/votes')
                .then(response => {
                    state.commit('SET_DATA', {name: 'votesListData', data: response.data});
                })
        },

        sendVote(state, payload) {
            axios.post('/api/v2/votes/create', {
                id: payload.id,
            })
                .then(response => {
                    state.commit('SET_DATA', {name: 'voteResult', data: response.data});
                    state.dispatch('votesList');
                })
        },

        sendProposal(state) {
            axios.post('/api/v2/votes/singleProposal/create', {
                singleProposal: state.state.singleProposal
            })
                .then(() => {
                    state.commit('SET_DATA', {name: 'hideFormProposal', data: true});
                })
        },
        versionList(state) {
            axios.get('/api/v2/version/')
                .then(response => {
                    state.commit('SET_DATA', {name: 'versionData', data: response.data.versionData});
                })
        },


    }
}
